import { Heading } from "@/components/ui/heading.tsx";
import type { ReactNode } from "react";
import { cn } from "cn";

const PAGE_TITLE_CLASSES = "text-4xl leading-none font-normal sm:text-4xl";

export interface PageTitleProps {
    children: ReactNode;
    className?: string;
}

export function PageTitle({ children, className }: PageTitleProps) {
    return (
        <Heading level={1} className={cn(PAGE_TITLE_CLASSES, className)} data-public>
            {children}
        </Heading>
    );
}
